<template>
  <div class="menu" style="background: url(static/images/backgroundcs.png) no-repeat bottom;
    background-color: #A7D7F5;
    background-size: 100%;
    height: 100%;">
      <div class="topLogo">
          <img class="leftLogo" src="static/images/logoblack.png">
          <img class="rightLogo" src="static/images/wsbsdt.png">
      </div>
      <div class="muenBoxs">
          <div class="parents">
            <!-- 报修申请 -->
            <div class="gridCell" v-if="allMenu.repairApplicationManagement" @click="openPage('/RepairApply', '')">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) 0% 73% no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">校园网络故障报修</p>
            </div>
            <!-- 维修管理 -->
            <div class="gridCell" v-if="allMenu.maintenanceManagement" @click="openPage('/RepairManger', '')">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) 0% 73% no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">维修管理</p>
            </div>
            <!-- 融合套餐问题 -->
            <div class="gridCell" v-if="allMenu.integrationPackageReview"  @click="openPage('/FusePackageProblem', '')">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) 0% 73% no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">融合套餐审核</p>
            </div>
            <!-- 延迟维修审核 -->
            <div class="gridCell" v-if="allMenu.delayedMaintenanceAudit"  @click="openPage('/DelayedMaintenanceAudit', '')">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) 0% 73% no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">延迟维修审核</p>
            </div>
            <!-- 退出登录 -->
            <div class="gridCell" @click="loginOut()">
                <div class="btimg d_icon_10" style="background: url(static/images/jt.png) 0% 73% no-repeat;
                background-size: 333.33%;
                background-color: #3C8DFF;">
                </div>
                <p class="text">退出登录</p>
            </div>
        </div>
      </div>
      
      
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../fetch/api";
import * as _ from "../util/tool";
import * as types from '../vuex/types';
import service from "@/fetch/service";

export default {
  data() {
    return {
        allMenu: {}
    };
  },
  computed:{
    pageParamsType: {
      // getter
      get: function () {
          return this.$route.query.type;
      }
    }
  },
  created() {
      _.isHaveToken(this.$router);
      this.checkPermission();
      console.log(this.pageParamsType)
      console.log(this.$route)
  },
  methods: {
    checkPermission() {
        api.get('/wx/permisson/dormmg/checkPermission', {})
        .then(res => {
            console.log(res);
            if (res.success) {
                this.allMenu = res.result
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    openPage(pageName, url) {
        if (url) {
            api.get(url, {})
            .then(res => {
                console.log(res);
                if (res.result) {
                    this.$router.push(pageName);
                }else {
                    _.toast("无权访问", 'fail');
                }

            })
            .catch(error => {
                console.log(error);
            });  
        }else {
            this.$router.push(pageName);
        }
    },
    loginOut() {
        // window.open(types.logoutURL, "_self")
        window.location.href = types.logoutURL;
        this.$router.replace("/login");
        //清除token
        sessionStorage.removeItem('token');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
.muenBoxs {
    padding: px2rem(20px);
    margin-top: px2rem(20px);
    .parents {
        position: relative;
        .gridCell {
            width: 33.33%;
            float: left;
            position: relative;
            margin-bottom: px2rem(30px);
            overflow: hidden;
            text-align: center;
            .btimg {
                width: px2rem(120px);
                height: px2rem(120px);
                border-radius: px2rem(10px);
                margin: 0 auto;
            }
            .d_icon_10 {
                background-position-x: 0;
                background-position-y: px2rem(-410px);
            }
            .text {
                margin-top: px2rem(20px);
                font-size: px2rem(28px);
            }
        }
    }
}

.menu {
    .topLogo {
        height: px2rem(100px);
        width: 100%;
        padding: px2rem(20px);
        background: #fff;
        display: flex;
        .leftLogo {
            width: 55%;
            align-self: center;
        }
        .rightLogo {
            width: 40%;
            align-self: center;
        }
    }
}
</style>


// WEBPACK FOOTER //
// indexMenuRepairApply.vue?7f3be7d8